import axios, { AxiosResponse } from 'axios'
import { BASE_API_URL } from './api'
import { ILeadStatus, IUserRow } from './types'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

const supportedInFilterCondition = ['userStatus.status', 'country']
const SupportedEqFilterCondition = ['id', 'shortId']

export const fetchLeads = (lazyParams: any, accessToken: string): Promise<any> => {
  const { page } = lazyParams
  // format the sorting
  let sort = ''
  if (lazyParams.sortOrder && lazyParams.sortField)
    sort = `&sort=${lazyParams.sortField},${lazyParams.sortOrder === -1 ? 'DESC' : 'ASC'}`

  // format the filters
  let filters = ''

  lazyParams.filters &&
  Object.keys(lazyParams.filters).forEach((filter) => {
    // date range filter
    if (['createdAt', 'updatedAt', 'lastVisit', 'lastVoipCall', 'lastAppCall', 'lastTransactionsAggregatedData.ltdDate', 'firstTransactionsAggregatedData.ftdDate'].includes(filter)) {
      let formattedFilters = lazyParams.filters[filter].value.split('/')

      // Parse the start date
      const date1 = formattedFilters[0].split('-')
      const firstDate = dayjs.utc(`${date1[2]}-${date1[1]}-${date1[0]}T00:00:00.000Z`)

      // Parse the end date if it exists, otherwise, use the same date for end time
      const date2 = formattedFilters[1] ? formattedFilters[1].split('-') : date1
      const secondDate = dayjs.utc(`${date2[2]}-${date2[1]}-${date2[0]}T23:59:59.999Z`)

      // Construct the filter string
      filters += `&filter=${filter}||between||${firstDate.toISOString()},${secondDate.toISOString()}`
    }
    // ftd filter
    else if (filter === 'firstFtdAmount') {
      filters += `&filter=${filter}||${
        lazyParams.filters[filter].value === 'Lead with FTD' ? 'notnull' : 'isnull'
      }||0`
    }
    // firstFtdDate filter and lastTransactionDate filter
    else if (
      filter === 'firstFtdDate' ||
      filter === 'lastTransactionDate' ||
      filter === 'notesAggregatedData.lastNoteDate'
    ) {
      let formattedFilters = lazyParams.filters[filter].value.split('/')
      const date = formattedFilters[0].split('-')
      const firstDate = date[2] + '-' + date[1] + '-' + date[0]
      filters += `&filter=${filter}||eq||${firstDate}`
    }
    // money filters
    else if (
      filter === 'aggregatedData.sumDeposit' ||
      filter === 'aggregatedData.netDeposit' ||
      filter === 'accounts.balance' ||
      filter === 'accounts.credit' ||
      filter === 'accounts.margin' ||
      filter === 'accounts.marginFree' ||
      filter === 'accounts.equity' ||
      filter === 'aggregatedData.ftdAmount' ||
      filter === 'accountSumAggregatedData.sumWithdrawal' ||
      filter === 'accountSumAggregatedData.sumReDeposit' ||
      filter === 'accountSumAggregatedData.sumEquity' ||
      filter === 'lastTransactionsAggregatedData.ltdAmount'
    ) {
      filters += `&filter=${filter}||eq||${lazyParams.filters[filter].value}`
    } else if (SupportedEqFilterCondition.includes(filter)) {
      filters += `&filter=${filter}||$eq||${lazyParams.filters[filter].value}`
    }
    // leadStatus and general
    else
      filters += `&filter=${filter}||$${supportedInFilterCondition.includes(filter) ? 'in' : 'contL'}||${
        lazyParams.filters[filter].value
      }`
  })

  return axios
    .get<IUserRow>(
      `${BASE_API_URL}?join=tags&limit=${
        lazyParams.rows
      }&join=notesAggregatedData||lastNote,lastNoteDate&page=${parseInt(
        page + 1,
        10,
      )}${sort}${filters}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    )
    .then((response: AxiosResponse) => response.data)
}

export const getLeadStatus = (accessToken: string) => {
  return axios
    .get<ILeadStatus[]>(`${BASE_API_URL}/status/v2`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((response) => response.data)
}
